import modelService from '@/services/model'

export default {
  // NOTE: some times we want to pull only tickets for a specific project or board, then we can use these contextualised methods.
  // We should not need these for anythingbut index, since we have direct access to tickets on the API

  projectIndex: (cbOk, cbErr, projectId, pagination) => {
    return modelService.index(cbOk, cbErr, `/projects/${projectId}/emails.json?${modelService.paginationParams(pagination)}`)
  },

  projectShow: (cbOk, cbErr, projectId, id) => {
    return modelService.show(cbOk, cbErr, `/projects/${projectId}/emails/${id}.json`)
  },

  projectUpdate: (cbOk, cbErr, projectId, instance) => {
    return modelService.update(cbOk, cbErr, instance, `/projects/${projectId}/emails/${instance.id}.json`)
  },

  projectDelete: (cbOk, cbErr, projectId, id) => {
    return modelService.delete(cbOk, cbErr, `/projects/${projectId}/emails/${id}.json`)
  }

}



// WEBPACK FOOTER //
// ./src/services/email.js